import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store/store";
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import Loading from "@/components/home/Loading.vue";
import UserInfoDataService from "@/services/UserInfoDataService";
import ResponseData from "@/types/ResponseData";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const newUrl = ref("");
const isLoading = ref(false);

/** モーダル以外をクリックした際にモーダルを閉じるために必要な関数 */
const element = ref<HTMLDivElement | null>(null); // 対象の要素
const clickOutside = (e: MouseEvent) => {
  // [対象の要素]が[クリックされた要素]を含まない場合
  if (e.target instanceof Node && !element.value?.contains(e.target)) {
    setTimeout(function () {
      if (store.state.isSubMenuOpen[0]) {
        for (let i = 0; i < store.state.isSubMenuOpen[0].length; i++) {
          for (let j = 0; j < store.state.isSubMenuOpen[0][i].length; j++) {
            store.state.isSubMenuOpen[0][i][j] = false;
          }
        }
      }
    }, 500);
  }
};

/** メインメニューからサブメニューを開閉するための関数 */
const toggleOpen = (index: number) => {
  if (store.state.isOpen[0][index] == false) {
    store.state.isOpen[0][index] = true;
  } else {
    for (let j = 0; j < store.state.isSubMenuOpen[0][index].length; j++) {
      store.state.isSubMenuOpen[0][index][j] = false;
    }
    store.state.isOpen[0][index] = false;
  }
};

/** メインメニューにリンクがある場合、別のウィンドウで表示する関数 */
const MenuOpenWindow = (subMenuItem: string) => {
  if (subMenuItem.url) {
    // 普通のMainMenuの場合、newUrlを作成する
    if (subMenuItem.id.includes("MM")) {
      newUrl.value = `${process.env.VUE_APP_ONPREMISE_URL_DOMAIN}main/TO_V2.asp?DEST=${subMenuItem.url}&CTLNO=${store.getters.loginNumber}`;
      window.open(newUrl.value, "_blank");
    } else {
      // User Applicationによるurlならそのまま使える
      newUrl.value = subMenuItem.url;
      window.open(newUrl.value, "_blank");
    }

    // access log append for alternative login
    if(store.state.isAltLogin == true){
      store.dispatch("setAccessLog",{mainMenuCode:subMenuItem.id, accessTime: new Date()});
    }
  }
};

onMounted(() => {
  addEventListener("click", clickOutside);
});

onBeforeUnmount(() => {
  removeEventListener("click", clickOutside);
});

const closemenu = () => {
  document.getElementById("mySidebar").style.display = "none";
  document.getElementById("openNav").style.display = "inline-block";
};

const openmenu = () => {
  document.getElementById("mySidebar").style.display = "block";
  document.getElementById("openNav").style.display = "none";
};

const checkIsLoginAdmin = (subMenuItem: any) => {
  if (store.getters.isAltLoginAdmin == true) {
    showPage(subMenuItem)
  } else {
    alert("You don't have permission to access this page.");
  }
}

const showPage = (subMenuItem: any) => {
  var newsObj = [];
  store.dispatch("setMainMenuCode", subMenuItem.id);
  if (
    subMenuItem.url != "" &&
    subMenuItem.url != null &&
    subMenuItem.url != "None"
  ) {
    // UserList画面振り分けのため
    store.dispatch("setFlg", "");
    if (subMenuItem.name == "User Inquiry") {
      store.dispatch("setFlg", "UserList");
      store.dispatch("setShowPage", subMenuItem.url);
    }
    store.dispatch("setChangePage", subMenuItem.url);
    store.dispatch("setShowPageTitle", subMenuItem.name);
    store.dispatch("setPageClickCount", store.getters.pageClickCount + 1);
    store.dispatch("setShowPage", subMenuItem.url);
    // Response改善対応のため start
    store.dispatch("setSelectedStation", null);
    store.dispatch("setSearchedUserList", null);
    store.dispatch("setIsPageLoad", true);
    store.dispatch("setPcCompanyListData", null);
    store.dispatch("setCompanyAdminListData", null);
    // Response改善対応のため end
  } else {
    isLoading.value = true;
    var subMenuList = store.getters.subMenuList;
    var strAllSubMenuId = "";
    if(store.getters.subMenuList != null){
      for(var i=0; i< subMenuList.length; i++){
        if(subMenuList[i]["id"] == subMenuItem.id){
          for(let newsInfo of subMenuList[i]["data"][0]["newsInfo"]){
            var splitData = newsInfo.Content.split(/^/gm);
            newsObj.push({
              startDate: newsInfo.startDate.substr(0, 10),
              importanceColor: newsInfo.importance.color,
              subject: newsInfo.Subject,
              content: splitData
            })
          }
          store.dispatch("setNewsData", newsObj);
          store.dispatch("setSubMenuItem", subMenuList[i]["data"][0]["subMenuInfo"]);
          break;
        }
      }
      for(var subMenu of store.getters.subMenuItem){
        strAllSubMenuId = strAllSubMenuId + subMenu.id;
      }
      store.dispatch("setShowPageTitle", subMenuItem.name);
      store.dispatch("setShowPage", "SubMenu");
      store.dispatch("setIsNewsFlg", subMenuItem.newsFlg);
      store.dispatch("setShowedMenuList", strAllSubMenuId);
      isLoading.value = false;
    }else{
      const param = {
        mainMenuCodeList: store.getters.subExistMenu,
        userId: store.getters.cognitoUserName
      };
      UserInfoDataService.getSubMenuList(param)
        .then((response: ResponseData) => {
          store.dispatch("setSubMenuList", response.data);
          subMenuList = response.data;
          for(var i=0; i< subMenuList.length; i++){
            if(subMenuList[i]["id"] == subMenuItem.id){
              for(let newsInfo of subMenuList[i]["data"][0]["newsInfo"]){
                var splitData2 = newsInfo.Content.split(/^/gm);
                newsObj.push({
                  startDate: newsInfo.startDate.substr(0, 10),
                  importanceColor: newsInfo.importance.color,
                  subject: newsInfo.Subject,
                  content: splitData2
                })
              }
              store.dispatch("setNewsData", newsObj);
              store.dispatch("setSubMenuItem", subMenuList[i]["data"][0]["subMenuInfo"]);
              break;
            }
          }
          for(var subMenu of store.getters.subMenuItem){
            strAllSubMenuId = strAllSubMenuId + subMenu.id;
          }
          store.dispatch("setShowPageTitle", subMenuItem.name);
          store.dispatch("setShowPage", "SubMenu");
          store.dispatch("setIsNewsFlg", subMenuItem.newsFlg);
          store.dispatch("setShowedMenuList", strAllSubMenuId);
          isLoading.value = false;
        })
        .catch((e: Error) => {
          console.log(e);
        });
    }
  }

  // access log append for alternative login
  if(store.state.isAltLogin == true){
    store.dispatch("setAccessLog",{mainMenuCode:subMenuItem.id, accessTime: new Date()});
  }
};

const goToPC = () => {
  store.dispatch("setSelectedStation", null);
  router.push("/PcDownload");
};

const goToSalesNote = (subMenuItem: any) => {
  store.dispatch("setMainMenuCode", subMenuItem.id);
  router.push("/KDP_SalesNote");
};

const __returned__ = { router, newUrl, isLoading, element, clickOutside, toggleOpen, MenuOpenWindow, closemenu, openmenu, checkIsLoginAdmin, showPage, goToPC, goToSalesNote, store, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})